import { createTheme } from "@mui/material/styles";

const { breakpoints } = createTheme();

const theme = createTheme({
  mixins: {
    toolbar: {
      minHeight: "50px",
      maxHeight: "175px",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          [breakpoints.down("xs")]: {
            fontSize: "85%",
          },
        },
        body: {
          color: "#000000",
          margin: "0",
          padding: "0",
          backgroundColor: "#fff",
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
          msOverflowStyle: "-ms-autohiding-scrollbar",
        },
        "a:focus-visible": {
          outline: "-webkit-focus-ring-color auto 1px !important",
        },
        mark: {
          backgroundColor: "rgb(255, 255, 0, 0.3)",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        colorSecondary: {
          "&.Mui-checked": {
            color: "#D52B1E",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            paddingTop: "0px",
            paddingBottom: "0px",
            paddingLeft: "0px",
            paddingRight: "0px",
            fontSize: "0.875rem",
            "& .MuiInputBase-input::placeholder": {
              color: "#6A6A6A",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#C5C5C5",
              borderWidth: "1px",
            },
            "&:hover:not(.Mui-focused)": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#3A3A3A",
                borderWidth: "1px",
              },
            },
            "&.Mui-focused": {
              outline: "3px solid #505050",
              outlineOffset: "2.5px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#3A3A3A",
                borderWidth: "1px",
              },
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 400,
          transition: "color .01s",
          backgroundColor: "#d52b1e",
          "&.Mui-disabled": {
            backgroundColor: "#eeeeee",
            color: "#999999",
          },
        },
        outlined: {
          "&&&": {
            borderWidth: 3,
            borderColor: "#D52B1E",
          },
          "&&&.Mui-disabled": {
            backgroundColor: "#eeeeee",
            color: "#999999",
            borderColor: "#dddddd",
            borderWidth: 3,
          },
        },
        text: {
          backgroundColor: "transparent",
          color: "black",
          textDecoration: "underline",
          "&:hover": {
            backgroundColor: "transparent",
            color: "black",
            textDecoration: "underline",
          },
        },
        containedPrimary: {
          backgroundColor: "#F9F9F9",
          border: "#D52B1E 1px solid",
          color: "#252525",
          height: "38px",
          width: "90px",
          borderRadius: "25px",
          fontSize: "14px",
          letterSpacing: 0,
          lineHeight: "21px",
          textTransform: "none",
          "&&:hover": {
            backgroundColor: "#F9F9F9",
            color: "#252525",
          },
        },
        containedSecondary: {
          backgroundColor: "#FFFFFF",
          color: "#D52B1E",
          "&&:hover": {
            backgroundColor: "#dddddd",
            color: "#D52B1E",
          },
        },
        sizeLarge: {
          padding: "2rem 0",
          borderRadius: "3rem",
          height: "63px",
          fontSize: "1.25rem",
        },
        sizeSmall: {
          textTransform: "inherit",
          borderRadius: "3px",
          "&&:hover": {
            borderRadius: "3px",
            backgroundColor: "rgba(0,0,0,0.03)",
          },
        },
        textSizeSmall: {
          fontWeight: 400,
          fontSize: "0.875rem",
          lineHeight: "1rem",
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            backgroundColor: "#DEDEDE",
          },
        },
        textColorInherit: {
          opacity: 1,
          color: "#222222",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#D52B1E",
          "&& span": {
            height: ".5rem",
          },
          "&& svg": {
            height: "1.3rem",
            width: "1.3rem",
          },
          "&.Mui-checked": {
            color: "#D52B1E",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "#DEDEDE",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          maxWidth: "200px",
          borderRadius: "3px",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          fontSize: "0.875rem",
        },
        arrow: {
          color: "rgba(0, 0, 0, 0.8)",
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid #dddddd",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&& td:not(:first-of-type)": {
            borderLeft: "1px solid #dddddd",
          },
        },
        head: {
          borderBottom: "1px solid #666666",
          "&& th:not(:first-of-type)": {
            borderLeft: "1px solid #dddddd",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "none",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFF",
        },
        input: {
          "&::placeholder": {
            textOverflow: "ellipsis !important",
            opacity: 1,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: "12.5px 14px",
        },
        multiline: {
          padding: "12.5px 14px",
        },
      },
    },

    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
      styleOverrides: {
        root: {
          "& a:-webkit-any-link:focus-visible": {
            outlineOffset: "1px",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: "#D52B1E",
          },
        },
      },
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          marginLeft: "12px",
          marginRight: "12px",
          fontSize: "0.5rem",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "& .MuiSelect-icon": {
            color: "#d52b1e",
            marginRight: "0.75rem",
          },
          "& .placeholder": {
            color: "#6a6a6a",
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          position: "relative",
          "&:hover": {
            backgroundColor: "#f5f5f5",
            ".hover-check": {
              display: "inline-flex",
              alignItems: "center",
              color: "#1A1919",
            },
          },
          ".hover-check": {
            display: "none",
            position: "absolute",
            right: 16,
            top: "50%",
            transform: "translateY(-50%)",
          },
        },
      },
    },
  },
  palette: {
    primary: { main: "#d52b1e", light: "#FF6348", contrastText: "#FFFFFF" },
    secondary: { main: "#333333", light: "#999999", contrastText: "#000000" },
    background: {
      default: "#F9F9F9",
    },
    info: {
      main: "#00749E",
    },
    text: {
      primary: "#222222",
      secondary: "#666666",
    },
    common: {
      black: "#000000",
      white: "#FFFFFF",
    },
    grey: {
      50: "#f9f9f9",
      100: "#EEEEEE",
      200: "#DDDDDD",
      500: "#666666",
      700: "#222222",
      900: "#000000",
    },
    warning: { main: "#F57600" },
  },
  typography: {
    fontFamily: [
      "Roboto",
      "Merriweather",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      "Fira Sans",
      "Droid Sans",
      "Helvetica Neue",
      "sans-serif",
    ].join(","),
    h1: { fontSize: "2.75rem" },
    h2: { fontSize: "2.125rem" },
    h3: { fontSize: "1.5rem" },
    h4: { fontSize: "1.375rem" },
    h5: {
      color: "#191919)",
      fontSize: "1.125rem",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "1.875rem",
    },
    h6: {
      fontSize: "1.125rem",
      color: "rgba(0,0,0,0.6)",
      letterSpacing: "2.5px",
    },
    subtitle1: {
      fontSize: "0.875rem",
      textTransform: "uppercase",
      fontWeight: 500,
    },
    body1: { fontSize: "1rem", fontWeight: 400 },
    body2: { fontSize: "0.875rem", fontWeight: 400 },
    subtitle2: { fontSize: "0.625rem", fontWeight: 800 },
    caption: {
      color: "#6A6A6A",
      fontSize: "0.75rem",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "1.125rem",
    },
  },
});

export default theme;
